/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  ProblemDetails,
  QuestionnaireSessionApiOutContract,
  QuestionnaireSessionListItemStaffApiOutContract
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Returns the patient's questionnaire sessions that are tied to a visit, newest first.
 */
export const getPatientsPatientIdQuestionnaires = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<QuestionnaireSessionListItemStaffApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/questionnaires`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdQuestionnairesInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}/questionnaires`
    ] as const;
    }

export const getGetPatientsPatientIdQuestionnairesQueryKey = (patientId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}/questionnaires`
    ] as const;
    }

    
export const getGetPatientsPatientIdQuestionnairesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdQuestionnairesInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>> = ({ signal }) => getPatientsPatientIdQuestionnaires(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdQuestionnairesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>>
export type GetPatientsPatientIdQuestionnairesInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdQuestionnairesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnairesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnairesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the patient's questionnaire sessions that are tied to a visit, newest first.
 */

export function useGetPatientsPatientIdQuestionnairesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdQuestionnairesInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Returns the patient's questionnaire sessions that are tied to a visit, newest first.
 */
export const prefetchGetPatientsPatientIdQuestionnairesInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdQuestionnairesInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdQuestionnairesQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdQuestionnairesQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>> = ({ signal }) => getPatientsPatientIdQuestionnaires(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdQuestionnairesQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>>
export type GetPatientsPatientIdQuestionnairesQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdQuestionnaires<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnaires<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnaires<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the patient's questionnaire sessions that are tied to a visit, newest first.
 */

export function useGetPatientsPatientIdQuestionnaires<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdQuestionnairesQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Returns the patient's questionnaire sessions that are tied to a visit, newest first.
 */
export const prefetchGetPatientsPatientIdQuestionnairesQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdQuestionnairesQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdQuestionnairesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdQuestionnairesQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>> = ({ signal }) => getPatientsPatientIdQuestionnaires(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdQuestionnairesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>>
export type GetPatientsPatientIdQuestionnairesSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdQuestionnairesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnairesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnairesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the patient's questionnaire sessions that are tied to a visit, newest first.
 */

export function useGetPatientsPatientIdQuestionnairesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdQuestionnairesSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdQuestionnairesSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdQuestionnairesInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>> = ({ signal }) => getPatientsPatientIdQuestionnaires(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdQuestionnairesSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>>
export type GetPatientsPatientIdQuestionnairesSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdQuestionnairesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnairesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnairesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the patient's questionnaire sessions that are tied to a visit, newest first.
 */

export function useGetPatientsPatientIdQuestionnairesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdQuestionnairesSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Returns the patient's questionnaire session (completion state and answers) for the given session id.
 */
export const getPatientsPatientIdQuestionnairesSessionId = (
    patientId: string,
    sessionId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<QuestionnaireSessionApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/questionnaires/${encodeURIComponent(String(sessionId))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdQuestionnairesSessionIdInfiniteQueryKey = (patientId?: string,
    sessionId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}/questionnaires/${sessionId}`
    ] as const;
    }

export const getGetPatientsPatientIdQuestionnairesSessionIdQueryKey = (patientId?: string,
    sessionId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}/questionnaires/${sessionId}`
    ] as const;
    }

    
export const getGetPatientsPatientIdQuestionnairesSessionIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>>, TError = void | ProblemDetails | ErrorApiOutContract>(patientId: string,
    sessionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdQuestionnairesSessionIdInfiniteQueryKey(patientId,sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>> = ({ signal }) => getPatientsPatientIdQuestionnairesSessionId(patientId,sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId && sessionId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdQuestionnairesSessionIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>>
export type GetPatientsPatientIdQuestionnairesSessionIdInfiniteQueryError = void | ProblemDetails | ErrorApiOutContract


export function useGetPatientsPatientIdQuestionnairesSessionIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnairesSessionIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnairesSessionIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the patient's questionnaire session (completion state and answers) for the given session id.
 */

export function useGetPatientsPatientIdQuestionnairesSessionIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdQuestionnairesSessionIdInfiniteQueryOptions(patientId,sessionId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Returns the patient's questionnaire session (completion state and answers) for the given session id.
 */
export const prefetchGetPatientsPatientIdQuestionnairesSessionIdInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string,
    sessionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdQuestionnairesSessionIdInfiniteQueryOptions(patientId,sessionId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdQuestionnairesSessionIdQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError = void | ProblemDetails | ErrorApiOutContract>(patientId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdQuestionnairesSessionIdQueryKey(patientId,sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>> = ({ signal }) => getPatientsPatientIdQuestionnairesSessionId(patientId,sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId && sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdQuestionnairesSessionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>>
export type GetPatientsPatientIdQuestionnairesSessionIdQueryError = void | ProblemDetails | ErrorApiOutContract


export function useGetPatientsPatientIdQuestionnairesSessionId<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnairesSessionId<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnairesSessionId<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the patient's questionnaire session (completion state and answers) for the given session id.
 */

export function useGetPatientsPatientIdQuestionnairesSessionId<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdQuestionnairesSessionIdQueryOptions(patientId,sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Returns the patient's questionnaire session (completion state and answers) for the given session id.
 */
export const prefetchGetPatientsPatientIdQuestionnairesSessionIdQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdQuestionnairesSessionIdQueryOptions(patientId,sessionId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdQuestionnairesSessionIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError = void | ProblemDetails | ErrorApiOutContract>(patientId: string,
    sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdQuestionnairesSessionIdQueryKey(patientId,sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>> = ({ signal }) => getPatientsPatientIdQuestionnairesSessionId(patientId,sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdQuestionnairesSessionIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>>
export type GetPatientsPatientIdQuestionnairesSessionIdSuspenseQueryError = void | ProblemDetails | ErrorApiOutContract


export function useGetPatientsPatientIdQuestionnairesSessionIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnairesSessionIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnairesSessionIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the patient's questionnaire session (completion state and answers) for the given session id.
 */

export function useGetPatientsPatientIdQuestionnairesSessionIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdQuestionnairesSessionIdSuspenseQueryOptions(patientId,sessionId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdQuestionnairesSessionIdSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>>, TError = void | ProblemDetails | ErrorApiOutContract>(patientId: string,
    sessionId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdQuestionnairesSessionIdInfiniteQueryKey(patientId,sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>> = ({ signal }) => getPatientsPatientIdQuestionnairesSessionId(patientId,sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdQuestionnairesSessionIdSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>>
export type GetPatientsPatientIdQuestionnairesSessionIdSuspenseInfiniteQueryError = void | ProblemDetails | ErrorApiOutContract


export function useGetPatientsPatientIdQuestionnairesSessionIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnairesSessionIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdQuestionnairesSessionIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the patient's questionnaire session (completion state and answers) for the given session id.
 */

export function useGetPatientsPatientIdQuestionnairesSessionIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>>, TError = void | ProblemDetails | ErrorApiOutContract>(
 patientId: string,
    sessionId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdQuestionnairesSessionId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdQuestionnairesSessionIdSuspenseInfiniteQueryOptions(patientId,sessionId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




